import { render, staticRenderFns } from "./OrderRecordTab.vue?vue&type=template&id=69cfd3a6&scoped=true"
import script from "./OrderRecordTab.vue?vue&type=script&lang=js"
export * from "./OrderRecordTab.vue?vue&type=script&lang=js"
import style0 from "./OrderRecordTab.vue?vue&type=style&index=0&id=69cfd3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfd3a6",
  null
  
)

export default component.exports